export enum DomElementInteractionEventTypes {

    // mouse events
    MouseOver = "mouseover",
    MouseDown = "mousedown",
    MouseUp = "mouseup",
    Click = "click",

    // touch device events
    TouchStart = "touchstart",
    TouchEnd = "touchend",
    Tap = "tap",

    // combined events
    PointerTap = "pointertap",
    PointerAudio = "pointeraudio"
}